import sa from 'sa-sdk-javascript';

const PAGE_VIEW_METHOD = 'pageview_general';
const CLICK_METHOD = 'click_general';

sa.init({
  server_url: /www.dailyyoga.com.cn/.test(window.location.hostname)
    ? '//sc.dailyyoga.com.cn/sa?project=production'
    : '//114.55.73.129:8106/sa?project=default',
});

export function reportPageViewEvent(params) {
  sa.track(PAGE_VIEW_METHOD, params);
}

export function reportClickEvent(params) {
  sa.track(CLICK_METHOD, params);
}



// WEBPACK FOOTER //
// ./src/assets/js/saInstance.js